import { useToast } from "@/shared/hooks/useToast";
import { AnimatePresence, motion } from "framer-motion";
import { cn } from "@/shared/lib/utils";
import { CheckCircle2, XCircle, Info } from "lucide-react";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[100] flex flex-col items-center gap-2 pointer-events-none"
      style={{ paddingTop: "max(env(safe-area-inset-top), 16px)" }}
    >
      <AnimatePresence>
        {toasts.map((toast) => (
          <motion.div
            key={toast.id}
            initial={{ opacity: 0, y: -20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -10, scale: 0.95 }}
            transition={{ type: "spring", stiffness: 500, damping: 40 }}
            className={cn(
              "mx-4 px-4 py-3 rounded-xl shadow-ios-md",
              "glass-dark border border-white/[0.1] flex items-center gap-3",
              "pointer-events-auto max-w-sm w-full text-ios-label",
              toast.variant === "destructive" && "!bg-red-600/90 !border-red-500/30 text-white",
              toast.variant === "success" && "!bg-emerald-600/90 !border-emerald-500/30 text-white"
            )}
          >
            {toast.variant === "destructive" && (
              <XCircle className="w-5 h-5 flex-shrink-0" />
            )}
            {toast.variant === "success" && (
              <CheckCircle2 className="w-5 h-5 flex-shrink-0" />
            )}
            {!toast.variant && <Info className="w-5 h-5 flex-shrink-0 text-ios-blue" />}
            <div className="flex-1 min-w-0">
              {toast.title && (
                <p className="text-sm font-semibold leading-tight">{toast.title}</p>
              )}
              {toast.description && (
                <p className="text-sm leading-tight opacity-90">{toast.description}</p>
              )}
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
